import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { EmployeeDto } from '@api/models/employees/EmployeeDto';
import { EntityState } from '@api/models/enums/EntityState';
import { employeeService } from '@api/services/services';

type State = BaseType<EmployeeDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    lastName: '',
    email: '',
    phone: '',
    establishments: [],
    jobPosition: '',
    office: '',
    note: '',
    state: EntityState.Active,
  },
};

export const employeeSlice = baseSlice({
  name: 'employee',
  initialState,
});

export const selectEmployeeState = (state: RootState) => state.employee.state;
export const selectEmployee = (state: RootState) => state.employee.data;
export const employeeActions = employeeSlice.actions;

export const getEmployee = (employeeId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return employeeService.getById(employeeId);
  };

  getItem({
    dispatch,
    actions: employeeActions,
    getData: handleGetData,
  });
};
